export default __webpack_public_path__ + "static/logo-text-e607a81811a13393527f7aed194439b3.svg";